<template>
  <main class="sa-content">
    <div v-if="loading">
      <img
        src="../../assets/img/loader.svg"
        alt="loader"
        class="sa-loader sa-loader-top"
      />
    </div>
    <div v-else>
      <div class="sa-card-large">
        <labtech-details :d='details' />
      </div>
    </div>
  </main>
</template>
<script>
import LabTechDetails from "../../components/appointments/LabTechDetails.vue";
import { pro_url } from "../../../config/endpoints";

export default {
  components: {
    "labtech-details": LabTechDetails,
  },
  data() {
    return {
      details: null,
      userInfo: {},
      loading: false,
      app_stat: "3",
    };
  },
  mounted(){
      this.getData()
  },
  created() {
    let _self = this;
    let aid = this.$route.params.appid;
    _self.getData(aid);
    _self.userInfo = JSON.parse(_self.$localStorage.get("userdata")) || {};
  },
  methods: {
    getData(aid) {
      let _self = this;
      _self.loading = true;
      let wobj = {};
      _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/apt/${aid}`,
          query: wobj
        })
        .then(response => {
          if (response && response.status === 1000) {
            _self.details = response.data;
            let patDetails = {
              apnt_id: _self.details.apnt_id,
              pid: _self.details.pid,
              sanar_uid: _self.details.sanar_uid
            }
            _self.$localStorage.set('patDetails', JSON.stringify(patDetails))
            _self.app_stat = _self.details.status;
            if (_self.details.status == "7" || _self.details.status == "9") {
              _self.app_stat = "3";
            }
            _self.loading = false;
          } else {
          }
        })
        .catch(e => {
        });
    }
  },
};
</script>